import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export type IProfileResp = {
  /** int64，金币余额 */
  diamonds: number
  recharge_agency_info: {
    /** 是否币商 */
    is_recharge_agency: boolean
    /** 是否公开金币余额  */
    is_coin_public: boolean
    /** 交易说明 */
    trade_remark: string
  }
}
/** /live/account/profile */
export const getProfile = createAsyncThunk(
  '/live/account/profile',
  async (params, store: any) => {
    const resp = await http.post<{data: IProfileResp}>(
      '/live/account/profile',
      {
        ...store.getState().env.deviceinfo,
      }
    )

    return resp.data.data
  }
)

export type IAgencyInfoReq = {
  /** 是否公开余额 */
  is_coin_public: boolean
  /** 交易说明 */
  trade_remark: string
}
/** 编辑交易信息 live/pay/edit_recharge_agency_info */
export const editRechargeAgencyInfo = createAsyncThunk(
  '/live/pay/edit_recharge_agency_info',
  async (params: IAgencyInfoReq, store: any) => {
    const resp = await http.post('/live/pay/edit_recharge_agency_info', {
      ...store.getState().env.deviceinfo,
      ...params,
    })

    return resp.data
  }
)
/** 搜索mid /live/room/search_by_id */
export const searchById = createAsyncThunk(
  '/live/room/search_by_id',
  async (params: {id: string}, store: any) => {
    const resp = await http.post<{data: {list: any[]}}>(
      '/live/room/search_by_id',
      {
        ...store.getState().env.deviceinfo,
        ...params,
      }
    )
    return resp.data.data
  }
)
export type IAvatarUrl = {
  aspect_low: {
    urls: string[]
  }
  origin: {
    urls: string[]
  }
}
export type IAgencyTradeDetail = {
  /** 交易类型 10-自主充值 20-后台充值 30-发放金币 40-其他币商转入金币 */
  trade_type: number
  /** 交易金币数，转出时为负数 */
  trade_coins: number
  /** 交易时间，时间戳，秒 */
  trade_time: number
  /** 交易编码 */
  trade_no: string
  /** 交易备注 */
  trade_remark?: string
  /** 交易用户id */
  related_mid: number
  /** 交易用户名 */
  related_username: string
  /** 交易用户的头像，通用头像结构 */
  related_avatar_urls: IAvatarUrl
}

export type ITransferCoinReq = {
  /** 目标mid */
  target_mid: string
  /** 金币数量 */
  transfer_coins: number
  /** 备注 */
  transfer_remark?: string
}
export type ITransferCoinResp = {
  /** 错误信息 */
  err_msg: string
  /** 交易详情 */
  trade_detail: IAgencyTradeDetail
}
/** 发币 /live/pay/agency_transfer_coin */
export const agencyTransferCoin = createAsyncThunk(
  '/live/pay/agency_transfer_coin',
  async (params: ITransferCoinReq, store: any) => {
    const resp = await http.post('/live/pay/agency_transfer_coin', {
      ...store.getState().env.deviceinfo,
      ...params,
    })

    return resp.data.data
  }
)

export type IRecentResp = {
  /** 邀请人mid */
  inviter_mid: string
  /** 邀请人昵称 */
  inviter_name: string
  /** 被邀请人mid */
  invitee_mid: string
  /** 被邀请人昵称 */
  invite
}
/** 最近列表 /live/hg_family/invite_poll */
export const invitePoll = createAsyncThunk(
  '/live/hg_family/invite_poll',
  async (_params, store: any) => {
    const resp = await http.post<{data: {list: any[]}}>(
      '/live/hg_family/invite_poll',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

export type IAgencyRecordReq = {
  /** 翻页偏移量，第一页为空 */
  offset: string
  /** 开始时间，时间戳，秒 */
  start_time: number
  /** 结束时间，时间戳，秒 */
  end_time: number
}
export type IAgencyRecordResp = {
  list: IAgencyTradeDetail[]
  /** 下一页偏移量	 */
  next_offset: string
  /** 是否有下一页	 */
  has_more: boolean
}
/** 转账记录 /live/pay/agency_transfer_record */
export const agencyTransferRecord = createAsyncThunk(
  '/live/pay/agency_transfer_record',
  async (params: IAgencyRecordReq, store: any) => {
    const resp = await http.post<{data: IAgencyRecordResp}>(
      '/live/pay/agency_transfer_record',
      {
        ...store.getState().env.deviceinfo,
        ...params,
      }
    )
    return resp.data.data
  }
)

export type IAgencyInfo = {
  /** 用户id */
  mid: number
  /** 用户名 */
  username: string
  /** 头  */
  avatar_urls: IAvatarUrl
  /** 国旗url */
  flag_url: string
  /** 国家 */
  country: string
  /** 是否在线 */
  is_online: boolean
  /** 金币余额 */
  coins: number
  /** 是否公开金币余额 */
  is_coin_public: boolean
  /** 交易备注 */
  trade_remark: string
}
export type ICoinAgencyListResp = {
  list: IAgencyInfo[]
  /** 下一页偏移量	 */
  next_offset: string
  /** 是否有下一页	 */
  has_more: boolean
}

/** 币商列表 /live/pay/coin_agency_list */
export const coinAgencyList = createAsyncThunk(
  '/live/pay/coin_agency_list',
  async (params: {offset?: string}, store: any) => {
    const resp = await http.post<{data: ICoinAgencyListResp}>(
      '/live/pay/coin_agency_list',
      {
        ...store.getState().env.deviceinfo,
        ...params,
      }
    )
    return resp.data.data
  }
)

const defaultState: {
  account: IProfileResp
  searchList: any[]
  recentList: any[]
  currentTargetUser: {
    mid: string
    username: string
    avatar: string
  }
  agencyTradeDetail: IAgencyTradeDetail
  recordList: IAgencyTradeDetail[]
  partnerList: IAgencyInfo[]
} = {
  account: {
    diamonds: 0,
    recharge_agency_info: {
      is_recharge_agency: false,
      is_coin_public: false,
      trade_remark: '',
    },
  },
  searchList: [],
  recentList: [],
  currentTargetUser: {
    mid: '',
    username: '',
    avatar: '',
  },
  agencyTradeDetail: {
    trade_type: 0,
    trade_coins: 0,
    trade_time: 0,
    trade_no: '',
    trade_remark: '',
    related_mid: 0,
    related_username: '',
    related_avatar_urls: {
      aspect_low: {
        urls: [],
      },
      origin: {
        urls: [],
      },
    },
  },
  recordList: [],
  partnerList: [],
}
export const CoinerSlice = createSlice({
  name: 'Coiner',
  initialState: defaultState,
  reducers: {
    setCurrentTargetUser(state, action) {
      Object.assign(state.currentTargetUser, action.payload)
    },

    setSearchList(state, action) {
      Object.assign(state, {searchList: action.payload})
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProfile.fulfilled, (state, action) => {
      const {diamonds = 0, recharge_agency_info} = action.payload
      Object.assign(state.account, {
        diamonds,
        recharge_agency_info,
      })
    })

    builder.addCase(searchById.fulfilled, (state, action) => {
      const {list} = action.payload
      const searchList = []
      list.forEach((item) => {
        try {
          if (item.member) {
            searchList.push({
              mid: item.member.id,
              username: item.member.name,
              avatar: item.member.avatar_urls.aspect_low.urls[0],
            })
          }
        } catch (error) {
          console.log('error :>> ', error)
        }
      })
      // Object.assign(state.searchList, searchList)
      Object.assign(state, {searchList})
    })

    builder.addCase(invitePoll.fulfilled, (state, action) => {
      const {list} = action.payload
      const recentList = list.slice(0, 5)
      // Object.assign(state.recentList, recentList)
      Object.assign(state, {recentList})
    })

    builder.addCase(agencyTransferCoin.fulfilled, (state, action) => {
      const {trade_detail} = action.payload
      Object.assign(state.agencyTradeDetail, {
        ...trade_detail,
      })
    })

    builder.addCase(agencyTransferRecord.fulfilled, (state, action) => {
      const {list} = action.payload
      // Object.assign(state.recordList, list)
      Object.assign(state, {recordList: list})
    })

    builder.addCase(coinAgencyList.fulfilled, (state, action) => {
      const {list} = action.payload
      // Object.assign(state.partnerList, list)
      Object.assign(state, {partnerList: list})
    })
  },
})

export default CoinerSlice.reducer
export const CoinerAction = CoinerSlice.actions
export const useCoinerState = () => useSelector((state) => state.Coiner)
